import React from 'react';
import { Typography } from 'antd';
import { formatCents } from './promptUtils';

const { Text } = Typography;

export default function PromptTokenMeter({ estimates = [], heuristic = 0, loading = false }) {
  const primary = estimates[0];
  const tokens = primary?.tokens ?? heuristic;

  if (!tokens || tokens === 0) return null;

  const cost = primary?.est_cost_per_call;
  const exact = primary?.exact;
  const costStr = formatCents(cost);

  const parts = [];
  const tokenLabel = `${!exact && !loading ? '~' : ''}${tokens.toLocaleString()} tokens`;
  parts.push(tokenLabel);
  if (costStr) parts.push(costStr);

  return (
    <Text type="secondary" className="prompt-token-meter">
      {parts.join(' · ')}
    </Text>
  );
}
